/**
 * TanStack Query hooks for `plan-pause-for-low-season-customers`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	planPauseForLowSeasonCustomersQueryKeys,
	type CreatePlanPauseForLowSeasonCustomersBody,
	type ListPlanPauseForLowSeasonCustomersResponse,
	type PlanPauseForLowSeasonCustomersRow,
} from "./api";

export function usePlanPauseForLowSeasonCustomersList(): UseQueryResult<ListPlanPauseForLowSeasonCustomersResponse, Error> {
	return useQuery({
		queryKey: planPauseForLowSeasonCustomersQueryKeys.list(),
		queryFn: list,
	});
}

export function usePlanPauseForLowSeasonCustomersCreate(): UseMutationResult<PlanPauseForLowSeasonCustomersRow, Error, CreatePlanPauseForLowSeasonCustomersBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: planPauseForLowSeasonCustomersQueryKeys.all });
		},
	});
}

export function usePlanPauseForLowSeasonCustomersDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: planPauseForLowSeasonCustomersQueryKeys.all });
		},
	});
}
